import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ROUTES } from '../Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/homepage.css';

export const Logo: React.FC = () => (
  <span className="logoWrap">
    <img src="/LogoContainer.png" alt="ToothZap logo" className="logoImg" />
  </span>
);

export const Nav: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
const navRoutes: any = {
  'For Dentists': ROUTES.Fordentist,
  'For Labs': ROUTES.Forlabs,
  // 'How It Works': null,
  'Find a Dentist': ROUTES.Findadendtist,
};
  return (
    <nav className="tz-navbar navbar navbar-expand-lg">
      <div className="container tz-container">
        <a className="navbar-brand p-0" href="/">
          <Logo />
        </a>

        <button
          className="navbar-toggler border-0 shadow-none"
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-4">
  {Object.keys(navRoutes).map((label) => (
    <li className="nav-item" key={label}>
      <span
        className="nav-link tz-nav-link"
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(navRoutes[label])}
      >
        {label}
      </span>
    </li>
  ))}
</ul>
          <div className="d-flex gap-2 align-items-center mt-3 mt-lg-0">
            <button
              onClick={() => navigate(ROUTES.REGISTER)}
              className="btn btn-sm tz-btn-primary"
            >
              Book a Demo
            </button>
            <button
              onClick={() => navigate(ROUTES.LOGIN)}
              className="btn btn-sm tz-btn-text"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

